import api from 'api';

const eventsUrl = 'api/events';

export default {
    fetch: (dispatch, getState, params) => api.get({dispatch, getState, path:eventsUrl, params: {...params, passed: 0}})
}